export class ProfilePicture {
  id: string;
  type: string;
  createdDate: Date;
  fileUrl: string;
  status: string;
}
